module.exports = __webpack_public_path__ + "img/clip-641.3d9842b6.png";